import classNames from 'classnames'
import React from 'react'
import { RegisterOptions, UseFormRegister } from 'react-hook-form'

import InputErrorMessage from '../error-message'

interface Properties extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  Icon?: React.ElementType
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>
  registerOptions?: RegisterOptions
  label?: string
  containerClassName?: string
  subLabel?: string
  error?: string
}

const Textarea: React.FC<Properties> = ({
  id,
  className,
  register,
  registerOptions,
  name,
  Icon,
  containerClassName,
  label,
  error,
  subLabel,
  ...rest
}) => {
  return (
    <fieldset className={classNames('w-full', containerClassName)}>
      <legend className="w-full inline-flex items-end justify-between gap-4 ">
        {label && (
          <label
            htmlFor={id ?? `input-${name}`}
            className="text-current text-sm"
          >
            {label}
          </label>
        )}
        {subLabel && <span className="text-xs">{subLabel}</span>}
      </legend>
      <div className="relative w-full h-28 mt-0.5">
        <textarea
          id={id ?? `input-${name}`}
          className={classNames(
            'h-full resize-none w-full px-6 py-4 rounded-[1.25rem] border-gray-400 border transition-colors focus:border-gray-700 focus:shadow-md focus:outline-none placeholder-gray-700 text-gray-700 font-medium text-sm',
            {
              '!border-red-700 placeholder-red-700': !!error,
            },
            className
          )}
          {...rest}
          {...register(name, registerOptions)}
        />
        {Icon && (
          <span className="absolute right-6 top-0 h-full flex items-center justify-center">
            <Icon />
          </span>
        )}
      </div>
      {error && <InputErrorMessage message={error} />}
    </fieldset>
  )
}

export default Textarea
